/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get a plugin's startup, liveness, and dependency health.
 */
export const getPluginHealth = (
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/plugins/${encodeURIComponent(String(name))}/health`, method: 'GET', signal
    },
      options);
    }




export const getGetPluginHealthQueryKey = (name: string,) => {
    return [
    `/plugins/${name}/health`
    ] as const;
    }


export const getGetPluginHealthQueryOptions = <TData = Awaited<ReturnType<typeof getPluginHealth>>, TError = unknown>(name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginHealth>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginHealthQueryKey(name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginHealth>>> = ({ signal }) => getPluginHealth(name, requestOptions, signal);





   return  { queryKey, queryFn, enabled: name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getPluginHealth>>>
export type GetPluginHealthQueryError = unknown


/**
 * @summary Get a plugin's startup, liveness, and dependency health.
 */

export function useGetPluginHealth<TData = Awaited<ReturnType<typeof getPluginHealth>>, TError = unknown>(
 name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginHealth>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginHealthQueryOptions(name,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Re-check a plugin's dependencies and return the fresh aggregate.
 */
export const refreshPluginHealthDependencies = (
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/plugins/${encodeURIComponent(String(name))}/health/dependencies`, method: 'POST', signal
    },
      options);
    }




export const getRefreshPluginHealthDependenciesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPluginHealthDependencies>>, TError,{name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshPluginHealthDependencies>>, TError,{name: string}, TContext> => {

const mutationKey = ['refreshPluginHealthDependencies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshPluginHealthDependencies>>, {name: string}> = (props) => {
          const {name} = props ?? {};

          return  refreshPluginHealthDependencies(name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshPluginHealthDependenciesMutationResult = NonNullable<Awaited<ReturnType<typeof refreshPluginHealthDependencies>>>

    export type RefreshPluginHealthDependenciesMutationError = unknown

    /**
 * @summary Re-check a plugin's dependencies and return the fresh aggregate.
 */
export const useRefreshPluginHealthDependencies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPluginHealthDependencies>>, TError,{name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshPluginHealthDependencies>>,
        TError,
        {name: string},
        TContext
      > => {
      return useMutation(getRefreshPluginHealthDependenciesMutationOptions(options));
    }
    /**
 * @summary List installable and system plugins in the catalog.
 */
export const getPluginsCatalog = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/plugins/catalog`, method: 'GET', signal
    },
      options);
    }




export const getGetPluginsCatalogQueryKey = () => {
    return [
    `/plugins/catalog`
    ] as const;
    }


export const getGetPluginsCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getPluginsCatalog>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginsCatalog>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginsCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginsCatalog>>> = ({ signal }) => getPluginsCatalog(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginsCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginsCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getPluginsCatalog>>>
export type GetPluginsCatalogQueryError = unknown


/**
 * @summary List installable and system plugins in the catalog.
 */

export function useGetPluginsCatalog<TData = Awaited<ReturnType<typeof getPluginsCatalog>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginsCatalog>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginsCatalogQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






